export async function load(model, msaFile, treeFile) {
    model.setError(undefined);
    try {
        if (msaFile) {
            await model.setMSAFilehandle(msaFile);
        }
        if (treeFile) {
            await model.setTreeFilehandle(treeFile);
        }
    }
    catch (e) {
        model.setError(e);
    }
}
//# sourceMappingURL=util.js.map